const cargoAdminAbility = (can, cannot) => {
  can('manage', 'CargoAdmin');
};

export default cargoAdminAbility;
